import type React from 'react';

export const modalSafeChromeProps: Pick<
  React.HTMLAttributes<HTMLElement>,
  'onPointerDown' | 'onMouseDown'
> = {
  onPointerDown: (event) => event.stopPropagation(),
  onMouseDown: (event) => event.stopPropagation(),
};
